import OfflineScreen from './OfflineScreen';

export default OfflineScreen;
